export const YEAR_KEY = "yearReport";

export function getYearReport() {
  const stored = localStorage.getItem(YEAR_KEY);
  if (stored !== null) {
    return parseInt(stored, 10);
  }
  const currentYear = new Date().getFullYear();
  localStorage.setItem(YEAR_KEY, currentYear);
  return currentYear;
}

export function setYearReport(year) {
  localStorage.setItem(YEAR_KEY, year);
}

export function resetYearReport() {
  const currentYear = new Date().getFullYear() - 1;
  setYearReport(currentYear);
  return currentYear;
}
